import dayjs from 'dayjs'
export const ageGenerate = (
  birthDate: Date,
  calculateDate: Date = new Date(),
) => {
  const numberOfWeek = Math.ceil(
    dayjs(calculateDate).diff(birthDate, 'week', true),
  )

  const numberOfMonth = dayjs(calculateDate).diff(birthDate, 'month')
  const numberOfYear = Math.floor(numberOfMonth / 12)
  return {
    year: numberOfYear,
    month: numberOfMonth % 12,
    week: numberOfWeek,
  }
}
